import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのMarketplaceロゴアイコン
 */
export function ProductLogoSmallMarketplace({
  size = 20,
  color = "#646467",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_966_14910)">
        <path
          d="M8.60352 16.75C8.60352 17.7165 7.82002 18.5 6.85352 18.5C5.88702 18.5 5.10352 17.7165 5.10352 16.75C5.10352 15.7835 5.88702 15 6.85352 15C7.82002 15 8.60352 15.7835 8.60352 16.75Z"
          fill={color}
        />
        <path
          d="M16.1035 16.75C16.1035 17.7165 15.32 18.5 14.3535 18.5C13.387 18.5 12.6035 17.7165 12.6035 16.75C12.6035 15.7835 13.387 15 14.3535 15C15.32 15 16.1035 15.7835 16.1035 16.75Z"
          fill={color}
        />
        <path
          d="M6.60352 12.5H15.3535C15.7677 12.5 16.1035 12.8358 16.1035 13.25C16.1035 13.6642 15.7677 14 15.3535 14H6.60352V12.5Z"
          fill={color}
        />
        <path
          d="M3.76753 4.92289C3.45814 4.25991 3.94209 3.5 4.67371 3.5H17.5333C18.2649 3.5 18.7489 4.2599 18.4395 4.92289L15.8728 10.4229C15.7085 10.775 15.3552 11 14.9667 11H7.24038C6.85186 11 6.4985 10.775 6.3342 10.4229L3.76753 4.92289Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.603516 2.25C0.603516 1.83579 0.918469 1.5 1.33268 1.5H3.35352C3.64483 1.5 3.90979 1.66869 4.03306 1.93263L7.57473 9.51597C7.75 9.89127 7.58785 10.3376 7.21255 10.5129C6.83725 10.6882 6.39092 10.526 6.21564 10.1507L2.87603 3H1.33268C0.918469 3 0.603516 2.66421 0.603516 2.25Z"
          fill={color}
        />
        <path
          d="M8.14518 12.5C8.14518 12.7467 8.08435 12.9895 7.96807 13.2071C7.85178 13.4246 7.68364 13.6102 7.47854 13.7472C7.27343 13.8843 7.0377 13.9686 6.79221 13.9928C6.54672 14.017 6.29906 13.9802 6.07116 13.8858C5.84326 13.7914 5.64216 13.6423 5.48567 13.4516C5.32918 13.2609 5.22213 13.0346 5.17401 12.7926C5.12588 12.5507 5.13817 12.3006 5.20977 12.0646C5.28138 11.8285 5.4101 11.6138 5.58452 11.4393L6.64518 12.5H8.14518Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.64518 14V12.5H15.3535C15.7677 12.5 16.1035 12.8358 16.1035 13.25C16.1035 13.6642 15.7677 14 15.3535 14H6.64518Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1443 4.93842C13.4372 5.23131 13.4372 5.70619 13.1443 5.99908L6.64426 12.4991L5.5836 11.4384L12.0836 4.93842C12.3765 4.64553 12.8514 4.64553 13.1443 4.93842Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_966_14910">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.103516)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
